import { modal } from '@/js/App/PdModal/PdModal'
import { getNonStickySpinnerProps, getSpinnerProps, Spinner } from '@/js/UI/Components/Spinner'
import { PdFormsAjaxValidationExtension } from '@/js/UI/naja/PdFormsAjaxValidationExtension'
import { PdModalNajaAdapter } from '@peckadesign/pd-modal'
import naja, { Naja } from 'naja'
import {
	AjaxModalExtension,
	AjaxModalPreventRedrawExtension,
	BtnSpinnerExtension,
	FollowUpRequestExtension,
	ForceRedirectExtension,
	ScrollToExtension,
	SpinnerExtension,
	SuggestExtension,
	ToggleClassExtension
} from '@peckadesign/pd-naja'

declare global {
	interface Window {
		naja: Naja
	}
}

const spinnerExtension = new SpinnerExtension(Spinner, getSpinnerProps)

naja.registerExtension(
	new AjaxModalExtension(
		new PdModalNajaAdapter(modal, ['snippet--pdModalTitle', 'snippet--pdModalPerex', 'snippet--pdModal'])
	)
)
naja.registerExtension(new AjaxModalPreventRedrawExtension())
naja.registerExtension(new BtnSpinnerExtension(Spinner, getNonStickySpinnerProps))
naja.registerExtension(new FollowUpRequestExtension())
naja.registerExtension(new ForceRedirectExtension())
naja.registerExtension(new ScrollToExtension())
naja.registerExtension(spinnerExtension)
naja.registerExtension(new SuggestExtension(spinnerExtension, undefined, getNonStickySpinnerProps))
naja.registerExtension(new ToggleClassExtension())

naja.registerExtension(new PdFormsAjaxValidationExtension(Spinner, getNonStickySpinnerProps))

window.naja = naja

// We must attach Naja to the window load event.
if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', naja.initialize.bind(naja))
} else {
	naja.initialize()
}
